import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface DirtyState {
  isDirty: boolean;
  dirtyFields: Record<string, unknown>;
}

// Ref lives outside the store to avoid re-renders when updated
const dirtyStateRef = { current: { isDirty: false, dirtyFields: {} } as DirtyState };

interface RenterInviteDrawerState {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  dirtyStateRef: typeof dirtyStateRef;
  isFormDirty: () => boolean;
}

const useRenterInviteDrawerStore = create<RenterInviteDrawerState>()(
  devtools(
    () => ({
      isOpen: false as boolean,
      openDrawer: () => {
        dirtyStateRef.current = { isDirty: false, dirtyFields: {} };
        useRenterInviteDrawerStore.setState({ isOpen: true });
      },
      closeDrawer: () => {
        dirtyStateRef.current = { isDirty: false, dirtyFields: {} };
        useRenterInviteDrawerStore.setState({ isOpen: false });
      },
      dirtyStateRef,
      isFormDirty: () => {
        const { isDirty, dirtyFields } = dirtyStateRef.current;
        // isDirty can have false positives with shouldUnregister: true (isDirty=true but dirtyFields={})
        // Only consider form dirty if isDirty AND there are actual dirty fields
        const hasDirtyFields = Object.keys(dirtyFields).length > 0;
        return isDirty && hasDirtyFields;
      },
    }),
    { name: 'renter-invite-drawer-store' },
  ),
);

export default useRenterInviteDrawerStore;
